import { useLogto } from '@logto/react';
import { useEffect, type PropsWithChildren } from 'react';

const POST_LOGIN_KEY = 'morabi.postLoginPath';

export function RequireAuth({ children }: PropsWithChildren) {
  const { isAuthenticated, isLoading, signIn } = useLogto();

  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    try {
      sessionStorage.setItem(POST_LOGIN_KEY, window.location.pathname + window.location.search);
    } catch {
      // sessionStorage unavailable (private mode) — login still works, it just lands on the home page
    }
    void signIn(`${window.location.origin}/callback`);
  }, [isAuthenticated, isLoading, signIn]);

  if (isAuthenticated) return <>{children}</>;
  return <div className="auth-gate">A redirecionar para o início de sessão…</div>;
}
